import React from 'react'
import Grid from '@material-ui/core/Grid'
import moment from 'moment'
import Data from 'EurestoClass/Data'
import Constants from 'EurestoFonction/Constants'
import avatarPersonne from 'EurestoStyle/font/avatarPersonne.png'

moment.locale('fr')

export default props => <div style={{
  width: '100%',
  padding: 5,
  border: `1px solid ${EurestoColor('EurestoPrimary')}`,
  borderTop: 0,
  backgroundColor: props.color,
  color: 'white',
  borderLeft: 0,
  textAlign: 'left',
  borderRight: 0,
}}>
  <Grid container style={{ margin: 0, padding: 0, fontSize: 12 }} spacing={0}
        justify={'flex-start'} alignItems={'flex-start'} alignContent={'flex-start'}>
    <Grid item
          style={{
            margin: 0, padding: 2.5, backgroundColor: 'white'
          }}><img style={{ borderRadius: 5 }} width={25}
                  alt={Data.get(Constants.module.CONFIGURATION, Constants.donnee.utilisateur, { id: props.action.user_id }).slibelle}
                  src={
                    Data.get(Constants.module.CONFIGURATION, Constants.donnee.utilisateur, { id: props.action.user_id }).media_lien || avatarPersonne
                  }/></Grid>


    <Grid item xs
          style={{
            margin: 0, padding: 0, paddingLeft: 5
          }}>
      <Grid container alignContent={'flex-start'} spacing={0}
            direction={'row'}
            style={{
              margin: 0, padding: 0
            }}>
        <Grid item xs
              style={{
                margin: 0, padding: 0,
                lineHeight: 1.2
              }}>
            <span style={{
              fontSize: '12px',
              margin: '0px 1px',
              lineHeight: 1.2
            }}>
              <i style={{ margin: '0px 1px', fontSize: 12 }}
                 className={'ei-' + (props.action.type_action_id === Constants.typeAction.FermetureDossier && 'commun_fermer' || 'commun_reouvrir')}/>
              <i
                style={{
                  fontSize: '12px',
                  lineHeight: .9,
                  margin: '0px 1px'
                }}>{Data.get(Constants.module.CONFIGURATION, Constants.donnee.utilisateur, { id: props.action.user_id }) !== undefined ? Data.get(Constants.module.CONFIGURATION, Constants.donnee.utilisateur, { id: props.action.user_id }).slibelle : ''},
                <i
                  style={{
                    fontSize: '12px', margin: '0px 1px 0px 2px'
                  }}
                  className={'fa fa-clock-o'}/>{moment(props.action.date_creation).format('DD[/]MM[/]YY LT')}
              </i></span>
        </Grid>
      </Grid>
      <Grid item xs={12}
            style={{
              margin: 0, padding: 0,
              lineHeight: 1.2,
              fontWeight: 'bold'
            }}>
        {props.action.message}
      </Grid>
    </Grid>
  </Grid>
</div>


// WEBPACK FOOTER //
// ./app/App/Module/SDD/Component/LineBreakText/index.js